<template>
  <vs-row v-if="completed_experiences.length > 0">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" class="w-full xl:w-9/12">
      <vx-card :class="cardClass">
        <div>
          <heading :size="$route.params.id ? 'h2' : 'h1'" style-size="h4" class="mb-2"
            >Thank you Letter</heading
          >
          <p class="my-5">
            You now need to complete a Thank you letter to send to the employer who hosted you.
          </p>
          <p class="my-5">Complete the form below to generate this letter.</p>
          <div class="vx-row mb-6" v-show="completed_experiences.length > 1 && canChooseItem">
            <div class="vx-col w-full">
              <label class="vs-input--label">
                Select Work Experience
                <select
                  v-model="vje_id"
                  class="defaultselect mt-0"
                  style="width: 100%"
                  @change="changedVje"
                >
                  <option value="0">
                    Please select the Job Experience you want to add this Thank you Letter to
                  </option>
                  <option
                    v-for="vje in completed_experiences"
                    :key="vje.student_vje_id"
                    :value="vje.student_vje_id"
                  >
                    {{ vje.vje }} (Completed: {{ vje.date }})
                  </option>
                </select>
              </label>
            </div>
          </div>
          <form id="form" @submit.prevent="submitForm">
            <heading size="h2" style-size="h6" class="mb-2">Employee's Information</heading>
            <div class="vx-row mb-4">
              <div class="vx-col xl:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.student_name"
                  autocomplete="name"
                  label="Your Name"
                  aria-label="Your Name"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.student_email"
                  autocomplete="email"
                  label="Your Email Address"
                  aria-label="Your Email Address"
                  @change="handleChange"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.student_school"
                  autocomplete="organization"
                  label="Your School"
                  aria-label="Your School"
                  @change="handleChange"
                />
              </div>
            </div>

            <heading size="h2" style-size="h6" class="mb-2 mt-8">Employer's Information</heading>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.name"
                  label="Name"
                  aria-label="Name"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col xl:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.street"
                  label="Street Address"
                  aria-label="Street Address"
                  @change="handleChange"
                />
              </div>
              <div class="vx-col lg:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.town"
                  label="Town"
                  aria-label="Town"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col xs:w-1/2 lg:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.state"
                  label="State"
                  aria-label="State"
                  @change="handleChange"
                />
              </div>
              <div class="vx-col xs:w-1/2 lg:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.postcode"
                  label="Post Code"
                  aria-label="Post Code"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.phone"
                  label="Phone Number"
                  aria-label="Phone Number"
                  @change="handleChange"
                />
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.email"
                  label="Email"
                  aria-label="Email"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="vx-row mb-10">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.date"
                  :label="'Today\'s Date (example: ' + todayDate + ')'"
                  :aria-label="'Today\'s Date (example: ' + todayDate + ')'"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="vx-row mb-4 mt-5">
              <div class="vx-col md:w-1/2 w-full">
                <label class="vs-input--label">
                  Name and details of letter recipient
                  <vs-textarea
                    height="100px"
                    class="w-full"
                    v-model="data.recipient"
                    @change="submitForm(false)"
                  />
                </label>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col md:w-1/2 w-full">
                <label class="vs-input--label">
                  Who is this letter addressed to?
                  <vx-input-group class="mb-base">
                    <template slot="prepend">
                      <div class="prepend-text">
                        <span class="text-black">Dear</span>
                      </div>
                    </template>
                    <vs-input v-model="data.addressed_to" @change="handleChange" />
                  </vx-input-group>
                </label>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col w-full">
                <label class="vs-input--label">
                  Letter Body
                  <vs-textarea
                    height="300px"
                    class="w-full"
                    v-model="data.letter_body"
                    @change="submitForm(false)"
                  />
                </label>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col w-full">
                <span>Yours sincerely,</span>
              </div>
            </div>
            <div class="vx-row mb-10">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="w-full"
                  v-model="data.signature"
                  label="Your Name"
                  aria-label="Your Name"
                  @change="handleChange"
                />
              </div>
            </div>

            <button class="btn btn-primary btn-size-medium mr-3" :disabled="vje_id == 0">
              Save
            </button>
            <button
              id="view-thank-you-letter-btn"
              class="btn btn-secondary btn-size-medium mr-3"
              @click="downloadThankyouLetter"
              v-if="canDownload"
            >
              View Thank you Letter
            </button>
            <vs-progress
              indeterminate
              color="primary"
              v-if="downloadingThankyouLetter"
            ></vs-progress>
          </form>
        </div>
      </vx-card>
    </vs-col>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      class="w-full xl:w-3/12 pt-10 xl:pl-10 xl:pt-0"
      v-if="showTips"
      role="complementary"
    >
      <vx-card>
        <heading size="h2" style-size="h4" class="mb-5">Tips & Tricks</heading>
        <p class="mb-5">"The only place where success comes before work is in the dictionary.”</p>
        <p>(Vince Lombardi)</p>
      </vx-card>
    </vs-col>
  </vs-row>
  <no-completed-vje v-else>
    <p class="mb-5">
      You need to complete a Job Experience before you can write a Thank you Letter.
    </p>
  </no-completed-vje>
</template>

<script>
import themeConfig from '@/../themeConfig';
import NoCompletedVje from '@/components/UI/students/NoCompletedVje';
import theApi from '@/mixins/theApi';
import store from '@/store/store';
import router from '@/router/router';

export default {
  components: { NoCompletedVje },
  data() {
    return {
      data: {
        student_name: '',
        student_email: '',
        student_school: '',
        name: '',
        street: '',
        town: '',
        state: '',
        postcode: '',
        phone: '',
        email: '',
        date: '',
        recipient: '',
        addressed_to: '',
        letter_body: '',
        signature: '',
      },
      //completed_experiences: [],
      vje_id: 0,
      sidebarWidth: themeConfig.sidebarWidth,
      canDownload: false,
      downloadingThankyouLetter: false,
    };
  },
  methods: {
    async submitForm(formSubmitted = false) {
      if (parseInt(this.vje_id) === 0) {
        return;
      }

      this.showAlert = false;
      const form = document.getElementById('form');
      const formData = new FormData(form);
      for (const [key, value] of Object.entries(this.data)) {
        formData.append(key, JSON.stringify(value));
      }
      formData.append('vje_id', this.vje_id);

      theApi.methods
        .makeCall(
          false,
          'thankyou_letter/save',
          'post',
          formData,
          formSubmitted ? 'Thank you letter saved successfully!' : null,
          true,
        )
        .then(
          (data) => {
            const postwork_data = {
              student_vje_id: this.vje_id,
              data: data.postwork,
            };
            store.commit('authStudent/updateExperiencePostwork', postwork_data);
            this.canDownload = true;
          },
          () => {},
        );
    },
    async getThankyouLetter(vje_id) {
      const item = this.completed_experiences.find((i) => i.school_student_vje_id == vje_id);
      if (item && item.thankyou_letter) {
        this.data = Object.assign({}, item.thankyou_letter);
        this.canDownload = true;
      } else {
        this.data = {
          student_name: '',
          student_email: '',
          student_school: '',
          name: '',
          street: '',
          town: '',
          state: '',
          postcode: '',
          phone: '',
          email: '',
          date: '',
          recipient: '',
          addressed_to: '',
          letter_body: '',
          signature: '',
        };
        this.canDownload = false;
      }
    },
    changedVje() {
      this.getThankyouLetter(this.vje_id);
    },
    downloadThankyouLetter() {
      const form = document.getElementById('form');
      const formData = new FormData(form);
      for (const [key, value] of Object.entries(this.data)) {
        formData.append(key, JSON.stringify(value));
      }
      formData.append('vje_id', this.vje_id);

      this.downloadingThankyouLetter = true;
      theApi.methods.makeCall(false, 'thankyou_letter/save', 'post', formData, null, true).then(
        (data) => {
          const postwork_data = {
            student_vje_id: this.vje_id,
            data: data.postwork,
          };
          store.commit('authStudent/updateExperiencePostwork', postwork_data);

          const formDataTL = new FormData();
          formDataTL.append('student_vje_id', this.vje_id);
          theApi.methods.makeCall(false, 'thankyou_letter/download', 'post', formDataTL).then(
            (data) => {
              if (data.status == 'OK') {
                store.dispatch('popup/showIframePopup', data.url);
                store.commit('popup/setFocusElemOnPopupClose', 'view-thank-you-letter-btn');
                this.downloadingThankyouLetter = false;
              }
            },
            () => {
              this.downloadingThankyouLetter = false;
            },
          );
        },
        () => {},
      );
    },
    handleChange(e) {
      if (e.target.value) {
        this.submitForm();
      }
    },
  },
  computed: {
    settings() {
      return store.getters['authStudent/settings'];
    },
    experiences() {
      return store.getters['authStudent/experiences'];
    },
    completed_experiences() {
      let completed_experiences = [];
      for (let i = 0; i < this.experiences.length; i++) {
        if (this.experiences[i].completed_for_postwork) {
          const item = Object.assign({}, this.experiences[i].postwork);
          item.vje = this.experiences[i].vje.name;
          item.date = this.experiences[i].date_completed_formatted;
          item.student_vje_id = this.experiences[i].id;
          completed_experiences.push(item);
        }
      }
      return completed_experiences;
    },
    todayDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }
      return dd + '/' + mm + '/' + yyyy;
    },
    cardClass() {
      if (typeof this.$route.meta.showTips !== 'undefined' && !this.$route.meta.showTips) {
        return 'mt-base';
      }
      return '';
    },
    showTips() {
      if (typeof this.$route.meta.showTips !== 'undefined' && !this.$route.meta.showTips)
        return false;
      return true;
    },
    canChooseItem() {
      if (typeof this.$route.meta.canChooseItem !== 'undefined' && !this.$route.meta.canChooseItem)
        return false;
      return true;
    },
    contentWidth() {
      if (this.showTips) return themeConfig.contentWidth;
      return 12;
    },
  },
  mounted() {
    if (
      typeof this.settings['thankyou_letter'] !== 'undefined' &&
      this.settings['thankyou_letter'] == false
    ) {
      router.push('/student/dashboard');
    } else {
      if (this.completed_experiences.length >= 0) {
        if (
          typeof this.$route.meta.autoSelectTL !== 'undefined' &&
          typeof this.$route.meta.autoSelectTL
        ) {
          this.vje_id = this.$route.params.id;
          this.getThankyouLetter(this.vje_id);
        } else {
          if (this.completed_experiences.length == 1) {
            this.vje_id = this.completed_experiences[0].student_vje_id;
            this.getThankyouLetter(this.vje_id);
          }
        }
      }
    }
  },
  watch: {
    completed_experiences() {
      if (this.completed_experiences.length > 0) {
        this.vje_id = this.vje_id || this.completed_experiences[0].student_vje_id;
        this.getThankyouLetter(this.vje_id);
      }
    },
  },
};
</script>
<style scoped>
.prepend-text {
  border: 1px solid #cccccc;
  border-right: none;
}
button[disabled='disabled'] {
  cursor: not-allowed;
}
</style>
